export enum ProjectStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Expired    = 'Expired'
}
